/* global LanguageExport */

import React from 'react';
import Header from '../Header';
import Style from './activationSuccess.module.scss';

const PATH_LOGO = '/static/images/svg/FoxNow.svg';

const ActivationSuccess = () => {
  const {
    profileActivate_successButton: buttonText,
    profileActivate_successHeader: headerText,
    profileActivate_successText: successText,
  } = LanguageExport;
  const renderLogo = () => (
    <div>
      <img src={PATH_LOGO} alt="fox now" />
      <span>/</span>
      <span>Activate</span>
    </div>
  );
  const headerProps = {
    headerText: 'TEST',
    renderLogo,
    showHeaderDesktop: true,
  };
  return (
    <main className={Style.activationSuccess}>
      <Header {...headerProps} />
      <div className={Style.activationSuccessContainer}>
        <div className={Style.headerText}>{headerText}</div>
        <div className={Style.successText}>{successText}</div>
        <button className={Style.cta}>{buttonText}</button>
      </div>
    </main>
  );
};

export default ActivationSuccess;
